module.exports = __webpack_public_path__ + "wildlifecompliance_vue/img/shibaken.c4c9d81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shibaken.jpg
// module id = 311
// module chunks = 0